import normalizeString from 'utils/normalizeString'

const normalizedCampaign = normalizeString(process.env.REACT_APP_CAMPAIGN)

const normalizedSecondCampaign = normalizeString(
  process.env.REACT_APP_SECOND_CAMPAIGN
)

export const filtersDictionary = {
  Finalidade: 'finalidade',
  surroundingsSearch: 'busca-na-regiao',
  'modalidade-venda': 'Modalidade de venda',
  Situação: 'situacao',
  'Tipo de Compra': 'tipo-compra',
  'Tipo de Imóvel': 'tipo-imovel',
  'Tipo de Venda': 'tipo-venda',
  'Categoria de Venda': 'categoria_venda',
  'Formas de pagamento': 'formas-pagamento',
  Vendedor: 'vendedor',
  'forma-pagamento': 'Formas de pagamento',
  noDebts: 'sem-dividas',
  campaign: 'campanha-exclusiva',
  noLegalActions: 'sem-acoes-judiciais',
  visits: 'visitas',
  Desagio: 'desagio',
  searchId: 'buscaID',
  page: 'pagina',
  'Modalidade de venda': 'modalidade-de-venda',

  // Ordenação
  orderBy: 'ordenacao',
  relevante: 'relevancia',
  'valor-min': 'menorValor',
  'valor-max': 'maiorValor',
  desagio: 'Desagio',

  // Tipo de compra
  plataforma: 'plataforma',
  imobiliaria: 'imobiliaria',
  outros: 'outros',

  // Tipos de imovel
  Apartamento: 'apartamento',
  Area: 'area',
  Areas_app: 'areasAPP',
  Box_Garagem: 'boxGaragem',
  Casa: 'casa',
  Casa_Condominio: 'casaCondominio',
  Chacara_Sitio: 'chacaraSitio',
  Fazenda: 'fazenda',
  flat_hotel: 'flatHotel',
  Galpao: 'galpao',
  Salao_Comercial: 'salaoComercial',
  Loja_Salao_Comercial: 'lojaSalaoComercial',
  Lote: 'lote',
  Lote_Condominio: 'loteCondominio',
  Predio: 'predio',
  Sala: 'sala',
  Outros: 'Outros',

  // Finalidade
  Comercial: 'comercial',
  Consultar: 'indefinida',
  Incorporacao: 'incorporacao',
  Industrial: 'industrial',
  Misto: 'misto',
  Residencial: 'residencial',
  Rural: 'rural',

  // Situacao
  Desocupado: 'desocupado',
  Locado: 'alugado',
  Ocupado: 'ocupado',

  // Categoria venda
  venda_amigavel: 'venda_amigavel',
  venda_judicial: 'venda_judicial',
  outras: 'outras',

  // Tipo venda
  segundo_leilao: 'segundoLeilao',
  venda_direta: 'vendaDireta',
  primeiro_leilao: 'primeiroLeilao',
  corretor_autonomo: 'corretorAutonomo',
  concorrencia_publica: 'imovelDisputa',
  venda_direta_online: 'outros',
  leilao: 'Leilao',

  // Formas pagamento
  a_vista: 'aVista',
  parcelamento_direto: 'parcelamentoDireto',
  financiamento_imobiliario: 'financiamentoImobiliario',

  // Modalidade venda
  concorrencia: 'concorrencia',
  fila_unica: 'filaUnica',

  // desagio
  30: 'ate-30',
  50: 'ate-50',
  51: 'acima-de-50',

  // campanhas:
  [process.env.REACT_APP_CAMPAIGN]: normalizedCampaign,
  [process.env.REACT_APP_SECOND_CAMPAIGN]: normalizedSecondCampaign,

  // Vendedor
  '77628f11-00ec-d3c1-a5fb-5d8140ea843b': 'banco-do-brasil',
}

export const reverseFiltersDictionary = {
  [normalizedCampaign]: 'campaign',
  [normalizedSecondCampaign]: 'secondCampaign',

  finalidade: 'Finalidade',
  'modalidade-venda': 'Modalidade de venda',
  situacao: 'Situação',
  'tipo-compra': 'Tipo de Compra',
  'tipo-imovel': 'Tipo de Imóvel',
  'tipo-venda': 'Tipo de Venda',
  categoria_venda: 'saleCategory',
  vendedor: 'Vendedor',
  'Formas de pagamento': 'forma-pagamento',
  'sem-dividas': 'noDebts',
  'sem-acoes-judiciais': 'noLegalActions',
  visitas: 'visits',
  ordenacao: 'orderBy',
  relevancia: 'relevante',
  menorValor: 'valor-min',
  maiorValor: 'valor-max',
  Desagio: 'desagio',
  desagio: 'Desagio',
  buscaID: 'searchId',
  pagina: 'page',
  desconto: 'discountParam',
  'modalidade-de-venda': 'Modalidade de venda',

  // Tipo de compra
  plataforma: 'plataforma',
  imobiliaria: 'imobiliaria',
  leilao: 'Leilao',
  outros: 'outros',

  // Tipos de imovel
  apartamento: 'Apartamento',
  area: 'Area',
  areasAPP: 'Areas_app',
  boxGaragem: 'Box_Garagem',
  casa: 'Casa',
  casaCondominio: 'Casa_Condominio',
  chacaraSitio: 'Chacara_Sitio',
  fazenda: 'Fazenda',
  flatHotel: 'flat_hotel',
  galpao: 'Galpao',
  sala: 'Sala',
  salaoComercial: 'Salao_Comercial',
  lojaSalaoComercial: 'Loja_Salao_Comercial',
  lote: 'Lote',
  loteCondominio: 'Lote_Condominio',
  predio: 'Predio',
  Outros: 'Outros',

  // Finalidade
  comercial: 'Comercial',
  indefinida: 'Consultar',
  incorporacao: 'Incorporacao',
  industrial: 'Industrial',
  misto: 'Misto',
  residencial: 'Residencial',
  rural: 'Rural',

  // Situacao
  desocupado: 'Desocupado',
  alugado: 'Locado',
  ocupado: 'Ocupado',

  // Tipo venda
  Leilao: 'leilao',
  segundoLeilao: 'segundo_leilao',
  vendaDireta: 'venda_direta',
  primeiroLeilao: 'primeiro_leilao',
  corretorAutonomo: 'corretor_autonomo',
  imovelDisputa: 'concorrencia_publica',

  // Formas pagamento
  aVista: 'a_vista',
  parcelamentoDireto: 'parcelamento_direto',
  financiamentoImobiliario: 'financiamento_imobiliario',

  // Modalidade venda
  concorrencia: 'concorrencia',
  filaUnica: 'fila_unica',

  // Vendedor
  'banco-do-brasil': '77628f11-00ec-d3c1-a5fb-5d8140ea843b',

  Finalidade: 'finalidade',
  'Modalidade de venda': 'modalidade-venda',
  Situação: 'situacao',
  'Tipo de Compra': 'tipo-compra',
  'Tipo de Imóvel': 'tipo-imovel',
  'Tipo de Venda': 'tipo-venda',
  'Categoria de Venda': 'categoria_venda',
  Vendedor: 'vendedor',

  // desagio
  'ate-30': '30',
  'ate-50': '50',
  'acima-de-50': '51',
}
